import { memo } from 'react'
import { Choice } from 'components/Input/ChoiceGroup'
import PathChoiceFieldGroup from 'components/PathChoiceFieldGroup'
import { observer } from 'mobx-react'
import { PathFormFieldProps } from '../../interfaces/PathFormComponents.interface'

export enum Gender {
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

const GENDER_CHOICES: Choice<Gender>[] = [
  {
    label: 'Herr',
    value: Gender.MALE
  },
  {
    label: 'Frau',
    value: Gender.FEMALE
  }
]

type Props = PathFormFieldProps<Gender>

const PathGenderSelect = observer((props: Props) => (
  <PathChoiceFieldGroup {...props} choices={GENDER_CHOICES} />
))

export default memo(PathGenderSelect)
